export enum ListSpacing {
  default = '',
  spaceBetween = 'space-between',
  spaceEvenly = 'space-evenly',
  auto = 'auto',
  center = 'center'
}
